<div class="details-content-container">
@if (moleculeType() === MoleculeType.PROTEIN) {
  <cr-structure-viewer [obj]=obj() [xRefs]="xRefs()"></cr-structure-viewer>
  <mat-divider></mat-divider>
}

@if (xRefs()) {
  <cr-cross-references [crossRefs]=xRefs()></cr-cross-references>
} @else {
  <p> placeholder => There is no more information available<p>
}
</div>

